import { useCallback, useMemo, useState } from 'react';

/** Step navigation over a fixed number of steps (content steps + review). */
export const useWizard = (totalSteps: number) => {
  const [index, setIndex] = useState(0);

  const goNext = useCallback(
    () => setIndex((current) => Math.min(current + 1, totalSteps - 1)),
    [totalSteps],
  );
  const goBack = useCallback(
    () => setIndex((current) => Math.max(current - 1, 0)),
    [],
  );

  return useMemo(
    () => ({
      index,
      total: totalSteps,
      isFirst: index === 0,
      isLast: index === totalSteps - 1,
      goNext,
      goBack,
    }),
    [index, totalSteps, goNext, goBack],
  );
};
